import { Button, Spin, Typography } from 'antd'
import React, { useCallback, useMemo } from 'react'
import CommonModal from 'src/app/shared/components/modal/common-modal'
import { useTranslation } from 'react-i18next'
import './index.scss'
import { colorBorder } from 'src/app/themes/primaryThemeDefault'
import { IViewAccount } from 'src/app/shared/models/clientSetup.model'
import CommonTable from 'src/app/shared/components/common/table'
import { TableColumnDefs } from 'src/app/shared/components/common/new-table/table.model'

interface ViewAccountsModalProps {
  isOpen: boolean
  onClose: () => void
  listAccount?: IViewAccount[]
  clientName?: string
  loading: boolean
}

const ViewAccountsModal: React.FC<ViewAccountsModalProps> = ({ isOpen, onClose, listAccount, clientName, loading }) => {
  const { t } = useTranslation()

  const getHeaderName = useCallback(
    (field: string): string => {
      return t(`ClientSetup:account_by_user_list.${field}`)
    },
    [t],
  )

  const columnDefs: Array<TableColumnDefs> = useMemo(() => {
    return [
      {
        colId: 'no',
        field: 'no',
        width: 45,
        headerName: t(getHeaderName('no')),
        headerClass: 'custom-col-resize-indicator',
        cellRenderer: (params: any) => {
          return params.node.rowIndex + 1
        },

        sortable: false,
        resizable: false,
        hide: false,
        defaultSelect: true,
      },
      {
        colId: 'accountName',
        field: 'accountName',
        headerName: t(getHeaderName('accountName')),
        headerClass: 'custom-col-resize-indicator',
        sortable: false,
        resizable: false,
        minWidth: 180,
        defaultSelect: true,
      },
      {
        colId: 'accountNumber',
        field: 'accountNumber',
        headerName: t(getHeaderName('accountNumber')),
        headerClass: 'custom-col-resize-indicator',
        sortable: false,
        resizable: false,
        minWidth: 180,
        defaultSelect: true,
      },
      {
        colId: 'chargeAccountNumber',
        field: 'chargeAccountNumber',
        headerName: t(getHeaderName('chargeAccountNumber')),
        headerClass: 'custom-col-resize-indicator',
        sortable: false,
        resizable: false,
        minWidth: 180,
        defaultSelect: true,
      },
    ]
  }, [getHeaderName, t])

  return (
    <CommonModal
      title={t('ClientSetup:client_setup.clientSetupTitle') + clientName}
      size='middle'
      open={isOpen}
      onClose={onClose}
      footer={[
        <Button
          key='cancel-btn'
          style={{
            fontWeight: 600,
            width: '102px',
            height: '32px',
            border: `1px solid ${colorBorder}`,
          }}
          onClick={onClose}
        >
          <Typography.Text>{t('ClientSetup:client_setup.close')}</Typography.Text>
        </Button>,
      ]}
    >
      <div className='table-client-setup-view-account' style={{ position: 'relative' }}>
        {loading && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              backgroundColor: 'rgba(255, 255, 255)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
            }}
          >
            <Spin />
          </div>
        )}

        <CommonTable
          columnDefs={columnDefs}
          rowData={listAccount}
          displayAddBtn={false}
          displayUploadButton={false}
          handleChooseColumn={async () => await {}}
          handleSearch={async () => await {}}
          disableTableControl={true}
          displayActionColumn={false}
          getHeaderName={getHeaderName}
          className='view-account-modal'
        />
      </div>
    </CommonModal>
  )
}

export default ViewAccountsModal
